import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import {
  ExternalRoutes,
  Routes,
  measurementsRouteImplRef,
  rootRouteRef,
} from './routes';

export const metricsPlugin = createPlugin({
  id: 'metrics',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindMetricsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(metricsPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...metricsPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceMetricsPage = metricsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceMetricsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-metrics", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceMetricsExtension = metricsPlugin.provide(
  createComponentExtension({
    name: 'ConfidenceMetricsExtension',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-metrics-extension", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
    },
  }),
);

export const ConfidenceMeasurementsPage = metricsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceMeasurementsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-measurements", webpackPrefetch: 10 */ './MeasurementsRouter'
      ).then(m => m.MeasurementsRouter),
    mountPoint: measurementsRouteImplRef,
  }),
);
